import { Moment } from 'moment';
import { GenderTypeReport } from '../../people/Customers/Customers.types';
import {
  SituationsType,
  WorkOrderType,
} from '../movements/abcCurve/abcCurve.types';
import { SituationOptions } from '../movements/workOrders/WorkOrderReport.types';
import { DateFilterByTypes } from '../movements/dailyMovement/dailyMovement.types';

export type ReportFormat = 'PDF' | 'CSV' | 'HTML';

export enum WorkOrderItemType {
  PART = 'PART',
  SERVICE = 'SERVICE',
}

export enum WorkOrderDate {
  ENTRY = 'ENTRY',
  AUTHORIZATION = 'AUTHORIZATION',
  CLOSING = 'CLOSING',
  LEAVE = 'LEAVE',
}

// People
export interface ReportSuppliersFormValue {
  active: 0 | 1 | 2;
  companyType: string;
  uf: string;
  city: string;
}

export interface ReportSuppliersParams {
  active?: boolean;
  format: string;
  companyType?: string;
  uf?: string;
  city?: string;
}

export interface ReportCustomersFormValue {
  active: 0 | 1 | 2;
  companyType: string;
  genderType: GenderTypeReport;
  personType: string;
  creationDates?: [Moment, Moment];
  birthDates?: [Moment, Moment];
  uf: string;
  city: string;
  brandId: string;
  modelId: string;
  birthdateSpecific: boolean;
  recommendationIds: number[];
}

export interface ReportCustomersParams {
  active?: boolean;
  format: string;
  companyType?: string;
  fromBirthdayDate?: string;
  fromCreationDate?: string;
  genderType?: string;
  personType?: string;
  toBirthdayDate?: string;
  toCreationDate?: string;
}

export interface ReportCustomersProspectingFormValue {
  personType: string;
  itemType?: 1 | 2;
  active: 0 | 1 | 2;
  gender: GenderTypeReport;
  startDates?: [Moment, Moment];
  finalDates?: [Moment, Moment];
  description?: string;
  hiddenWithoutOs?: boolean;
  hiddenWithoutItems?: boolean;
}

export interface ReportCustomersProspectingForm {
  situation: SituationOptions;
  dateFilterBy: DateFilterByTypes;
  osType: WorkOrderType[];
  companiesIds?: number[];
  customersIds?: number[];
  endDate: Moment;
  startDate: Moment;
  finalOilChangeKm: number;
  finalOsKm: number;
  initialOilChangeKm: number;
  initialOsKm: number;
  serviceDescription: string;
  thirdParty: boolean;
  showAllContacts?: boolean;
  showOnlyMainContactsGroup?: boolean;
}

export interface ReportCustomersProspectingParams {
  thirdParty?: boolean;
  authorized?: boolean;
  canceled?: boolean;
  closed?: boolean;
  open?: boolean;
  companiesIds?: string;
  customersIds?: string;
  dateFilterBy?: string;
  endDate?: string;
  startDate?: string;
  serviceDescription?: string;
  finalOilChangeKm?: number;
  finalOsKm?: number;
  initialOilChangeKm?: number;
  initialOsKm?: number;
  osType?: WorkOrderType[];
  showAllContacts?: boolean;
  showOnlyMainContactsGroup?: boolean;
}

export interface ReportProspectingMigratedWorkOrdersForm {
  companyIds?: number[];
  customerIds?: number[];
  description: string;
  endDate: Moment;
  startDate: Moment;
  finalOsKm: number;
  initialOsKm: number;
  showAllContacts?: boolean;
  showOnlyMainContactsGroup?: boolean;
  showOnlyInsuredCustomers?: boolean;
  thirdParty: boolean;
  workOrderItemType?: WorkOrderItemType;
  workOrderDate: WorkOrderDate;
  workOrderStatus: SituationsType[];
  workOrderType: WorkOrderType[];
}

export interface ReportProspectingMigratedWorkOrdersParams {
  companyIds?: string;
  customerIds?: string;
  description?: string;
  endDate?: string;
  startDate?: string;
  finalOsKm?: number;
  initialOsKm?: number;
  licensePlate?: string;
  showAllContacts?: boolean;
  showOnlyMainContactsGroup?: boolean;
  showOnlyInsuredCustomers?: boolean;
  thirdParty?: boolean;
  workOrderItemType?: WorkOrderItemType;
  workOrderDate?: WorkOrderDate;
  workOrderStatus?: SituationsType[];
  workOrderType?: WorkOrderType[];
}

export interface CustomersTagsRequest {
  active?: boolean;
  companyType?: string;
  fromBirthdayDate?: string;
  fromCreationDate?: string;
  genderType?: string;
  personType?: string;
  toBirthdayDate?: string;
  toCreationDate?: string;
}

export interface CustomersTagsResponse {
  address: {
    city: string;
    district: string;
    number: string;
    state: string;
    street: string;
    zipCode: string;
  };
  cpfCnpj: string;
  name: string;
}

export interface ReportModalEmployeeFormValue {
  active: boolean;
  gender: string;
  birthday?: [Moment, Moment];
  uf: string;
  city: string;
  specificDate: boolean;
}

export interface ReportModalEmployeeParams {
  active?: boolean;
  area?: string;
  city?: string;
  companiesIds?: number[];
  format: string;
  fromBirthdayDate?: string;
  toBirthdayDate?: string;
  fromSalary?: number;
  toSalary?: number;
  gender?: string;
  uf?: string;
}

// Stock
export interface ReportManufacturersFormValues {
  name?: string;
}

export interface ReportManufacturersParams {
  format: string;
  name?: string;
}

export interface ReportGroupsFormValues {
  description?: string;
  area?: string;
}

export interface ReportGroupsParams {
  format: string;
  description?: string;
  area?: string;
}

// Account
export interface ReportDocumentTypesFormValue {
  description: string;
  fiscalDoc: boolean;
}

export interface ReportDocumentTypesParams {
  description?: string;
  fiscalDoc?: boolean;
  format: string;
}

export interface InsurerReportFormValues {
  name?: string;
  active?: 0 | 1;
  uf?: string[];
  cityIds?: string[];
}

export interface InsurerReportData {
  id: number;
  name: string;
  address: string;
  email: string;
  phone: string;
}
export interface customerCsvData {
  id: number;
  name: string;
  address: string;
  email: string;
  phone: string;
  birthDate?: string;
  creation: string;
  recommendationName: string;
  cpfCnpj?: string;
}
